const FormStep = ({step, children, currentStep}) => {
    return (
        <div className={`step step${step} mb-4 mb-lg-5 ${step !== currentStep ? 'd-none' : 'd-block'}`}>
            {children}
        </div>
    )
}

export default FormStep;
